export default {"src":"/_next/static/media/Referral_Scheme.cd392f7f.svg","height":39,"width":41,"blurWidth":0,"blurHeight":0};